import { render, staticRenderFns } from "./PpmTable.vue?vue&type=template&id=04b1aaa2"
import script from "./PpmTable.vue?vue&type=script&lang=ts"
export * from "./PpmTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports